<script setup>
import {computed, onMounted, ref} from 'vue';
import {usePage} from '@inertiajs/vue3';
import {loadLanguageAsync, isLoaded} from 'laravel-vue-i18n'
import Header from "@/Components/Header.vue";
import ToastMessage from "@/Components/ToastMessage.vue";
import LoaderIcon from "@/Svgs/LoaderIcon.svg.vue"

const page = usePage();
const user = computed(() => page.props.auth.user);
const message = computed(() => page.props.flash.message);
const isRequiredAuthCode = computed(() => page.props.auth.requiredAuthCode);

const translationsLoaded = ref(false)
const locale = document.documentElement.lang || 'fr'

onMounted(async () => {
    if (!isLoaded(locale)) {
        await loadLanguageAsync(locale)
    }
    translationsLoaded.value = true
})
</script>

<template>
    <div v-if="translationsLoaded">
        <Header :isRequiredAuthCode="isRequiredAuthCode" :user="user" />
        <main>
            <slot />
        </main>
        <ToastMessage v-if="message" :message="message"/>
    </div>
    <div v-else>
        <div class="loaderPage">
            <LoaderIcon />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.loaderPage {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 100%;
}
</style>
